/**
 * Initializes featured collection carousels that depend on the global Swiper build.
 */
(() => {
  const roots = () => document.querySelectorAll('[data-store-featured-collection]');

  const syncNav = (root, swiper) => {
    const prev = root.querySelector('[data-store-fc-prev]');
    const next = root.querySelector('[data-store-fc-next]');
    if (!(prev instanceof HTMLElement) || !(next instanceof HTMLElement)) return;

    const atStart = swiper.isBeginning;
    const atEnd = swiper.isEnd;
    prev.setAttribute('aria-disabled', atStart ? 'true' : 'false');
    next.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
    prev.classList.toggle('is-disabled', atStart);
    next.classList.toggle('is-disabled', atEnd);
  };

  const initRoot = (root) => {
    if (!(root instanceof HTMLElement) || root.dataset.storeFcReady === 'true') return;

    const el = root.querySelector('[data-store-fc-swiper]');
    if (!(el instanceof HTMLElement) || el.swiper) return;
    if (typeof window.Swiper !== 'function') return;

    const prev = root.querySelector('[data-store-fc-prev]');
    const next = root.querySelector('[data-store-fc-next]');

    const swiper = new window.Swiper(el, {
      slidesPerView: 'auto',
      spaceBetween: 0,
      watchOverflow: true,
      speed: 450,
      navigation: {
        nextEl: next,
        prevEl: prev,
      },
      a11y: {
        prevSlideMessage: root.dataset.labelPrev || 'Previous',
        nextSlideMessage: root.dataset.labelNext || 'Next',
      },
      on: {
        init() {
          syncNav(root, this);
        },
        slideChange() {
          syncNav(root, this);
        },
        resize() {
          syncNav(root, this);
        },
      },
    });

    root.dataset.storeFcReady = 'true';
    return swiper;
  };

  const initAll = () => {
    roots().forEach(initRoot);
  };

  const waitForSwiper = (attempt = 0) => {
    if (typeof window.Swiper === 'function') {
      initAll();
      return;
    }
    if (attempt > 40) return;
    window.setTimeout(() => waitForSwiper(attempt + 1), 50);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => waitForSwiper());
  } else {
    waitForSwiper();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target;
    if (!(section instanceof HTMLElement)) return;
    const root = section.querySelector('[data-store-featured-collection]');
    if (root) {
      root.dataset.storeFcReady = 'false';
      waitForSwiper();
    }
  });
})();
